'use client';
import { useEffect } from 'react';

import HeroSection from './components/HeroSection';
import WhyChooseSection from './components/WhyChooseSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import ProductsSection from './components/ProductsSection';
import ImpactSection from './components/ImpactSection';
import TestimonialsSection from './components/TestimonialsSection';
import MissionSection from './components/MissionSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <main className="min-h-screen bg-background overflow-x-hidden">
      <HeroSection />
      <WhyChooseSection />
      <DifferentiatorsSection />
      <ProductsSection />
      <ImpactSection />
      <TestimonialsSection />
      <MissionSection />
      <CTASection />
      <Footer />
    </main>
  )
}